export const GET_CALENDAR = '[BUSINES CALENDAR] GET CALENDAR';
export const PERIOD_SUBMITTING_CONFIRMATION_MODAL = '[BUSINES CALENDAR] PERIOD SUBMITTING CONFIRMATION MODAL';
export const SUBMIT_MONTH = '[BUSINES CALENDAR] SUBMIT MONTH';
export const UN_SUBMIT_MONTH = '[BUSINES CALENDAR] UN SUBMIT MONTH';
export const INITIATE = '[BUSINES CALENDAR] INITIATE';
export const STORE_MONTH_DATA = 'STORE_MONTH_DATA';